module.exports = __webpack_public_path__ + "static/story2-small-thumbnails-100x100-067b15ef9a8f6aada41e8bc29525b358.jpg";